module.exports = __webpack_public_path__ + "static/an-introduction-to-general-systems-thinking-ca917e5e4781cff42a16157b544261b2.jpg";